/**
 * Smart Wishlist (/a/wishlist) — reliable Add to Cart.
 * App JS can break on this theme; we add via Shopify Cart API instead.
 */
(function () {
  function isWishlistPage() {
    return /\/a\/wishlist/i.test(window.location.pathname);
  }

  if (!isWishlistPage()) return;

  document.documentElement.classList.add('wishlist-page-active');
  document.body.classList.add('wishlistpage');

  if (window.isopureLenis && typeof window.isopureLenis.destroy === 'function') {
    try {
      window.isopureLenis.destroy();
      window.isopureLenis = null;
    } catch (e) {}
  }

  var wishlistApiCache = null;

  function getRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function parseIdsFromOnclick(el) {
    if (!el) return null;
    var onclick = el.getAttribute('onclick') || '';
    var nums = onclick.match(/\d{6,}/g);
    if (!nums || !nums.length) return null;
    if (nums.length >= 2) {
      return { productId: parseInt(nums[0], 10), variantId: parseInt(nums[1], 10) };
    }
    return { variantId: parseInt(nums[0], 10) };
  }

  function getProductCard(button) {
    return (
      button.closest('.product') ||
      button.closest('[data-product-id]') ||
      button.closest('.wishlistitem') ||
      button.closest('.col-md-6') ||
      button.closest('.col-sm-6')
    );
  }

  function getHandleFromCard(card) {
    if (!card) return null;
    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return null;
    var match = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : null;
  }

  function getVariantIdFromCard(card, button) {
    if (!card) return null;

    var sources = [
      button.getAttribute('data-variantid'),
      button.getAttribute('data-variant-id'),
      button.getAttribute('data-variant'),
      button.getAttribute('data-id'),
      button.dataset && button.dataset.variantid,
      card.getAttribute('data-variantid'),
      card.getAttribute('data-variant-id'),
      card.getAttribute('data-variant'),
      card.getAttribute('data-vid'),
      card.querySelector('[data-variantid]') && card.querySelector('[data-variantid]').getAttribute('data-variantid'),
      card.querySelector('[data-variant]') && card.querySelector('[data-variant]').getAttribute('data-variant'),
      card.querySelector('[name="id"]') && card.querySelector('[name="id"]').value,
      card.querySelector('input[name="variant"]') && card.querySelector('input[name="variant"]').value
    ];

    var onclickIds = parseIdsFromOnclick(button) || parseIdsFromOnclick(card.querySelector('.removebutton'));
    if (onclickIds && onclickIds.variantId) {
      sources.unshift(String(onclickIds.variantId));
    }

    for (var i = 0; i < sources.length; i++) {
      var value = parseInt(sources[i], 10);
      if (value > 0) return value;
    }
    return null;
  }

  function getWishlistApiUrl() {
    var base = getRoot() + 'a/wishlist?type=api&version=1&_=' + Date.now();
    if (typeof window.SWGetCustomerWishlistId === 'function') {
      var customerId = window.SWGetCustomerWishlistId();
      if (customerId && parseInt(customerId, 10) > 0) {
        return base + '&customerid=' + encodeURIComponent(customerId);
      }
    }
    if (typeof window.SWGetExpressWishlistId === 'function') {
      var wishlistId = window.SWGetExpressWishlistId();
      if (wishlistId) {
        return base + '&wishlistid=' + encodeURIComponent(wishlistId);
      }
    }
    return null;
  }

  function loadWishlistApi() {
    if (wishlistApiCache) {
      return Promise.resolve(wishlistApiCache);
    }
    var url = getWishlistApiUrl();
    if (!url) {
      return Promise.resolve(null);
    }
    return fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data && data.type === 'success' && Array.isArray(data.items)) {
          wishlistApiCache = data.items;
          return wishlistApiCache;
        }
        return null;
      })
      .catch(function () { return null; });
  }

  function matchItemFromApi(card, items) {
    if (!card || !items || !items.length) return null;
    var handle = getHandleFromCard(card);
    var titleEl = card.querySelector('h3, .text h3, .product-title');
    var title = titleEl ? titleEl.textContent.replace(/\s+/g, ' ').trim().toLowerCase() : '';
    var variantTitleEl = card.querySelector('.variant_title');
    var variantTitle = variantTitleEl ? variantTitleEl.textContent.replace(/\s+/g, ' ').trim().toLowerCase() : '';

    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (handle && item.handle === handle) {
        if (!variantTitle || !item.variant_title || item.variant_title.toLowerCase().indexOf(variantTitle.split('/')[0].trim()) !== -1) {
          return parseInt(item.variant_id, 10);
        }
      }
      if (title && item.title && item.title.toLowerCase() === title) {
        return parseInt(item.variant_id, 10);
      }
    }
    return null;
  }

  function resolveVariantId(button) {
    var card = getProductCard(button);
    var variantId = getVariantIdFromCard(card, button);
    if (variantId) {
      return Promise.resolve(variantId);
    }

    var handle = getHandleFromCard(card);
    if (handle) {
      return fetch(getRoot() + 'products/' + encodeURIComponent(handle) + '.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      })
        .then(function (res) { return res.json(); })
        .then(function (product) {
          if (!product || !product.variants || !product.variants.length) return null;
          var variantTitleEl = card && card.querySelector('.variant_title');
          var label = variantTitleEl ? variantTitleEl.textContent.replace(/\s+/g, ' ').trim().toLowerCase() : '';
          if (label) {
            var match = product.variants.find(function (v) {
              var vt = (v.title || '').toLowerCase();
              return vt === label || label.indexOf(vt) !== -1 || vt.indexOf(label.split('/')[0].trim()) !== -1;
            });
            if (match) return match.id;
          }
          return product.variants[0].id;
        })
        .catch(function () { return null; });
    }

    return loadWishlistApi().then(function (items) {
      return matchItemFromApi(card, items);
    });
  }

  function publishVariantAdd(addJson, cartContent) {
    // Match ProductForm (theme.js) — popup + cart count, same as rest of site
    var items = addJson && Object.prototype.hasOwnProperty.call(addJson, 'items')
      ? addJson.items
      : [addJson];

    document.dispatchEvent(
      new CustomEvent('variant:add', {
        bubbles: true,
        detail: {
          items: items,
          cart: cartContent
        }
      })
    );

    document.documentElement.dispatchEvent(
      new CustomEvent('cart:change', {
        bubbles: true,
        detail: {
          baseEvent: 'variant:add',
          cart: cartContent
        }
      })
    );
  }

  function addVariantToCart(variantId) {
    var sectionsToBundle = ['variant-added'];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:prepare-bundled-sections', {
        bubbles: true,
        detail: { sections: sectionsToBundle }
      })
    );

    var formData = new FormData();
    formData.set('id', String(variantId));
    formData.set('quantity', '1');
    formData.set('sections', sectionsToBundle.join(','));
    formData.set('sections_url', getRoot() + 'variants/' + variantId);

    return fetch(getRoot() + 'cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin',
      body: formData
    }).then(function (res) {
      return res.json().then(function (json) {
        if (!res.ok) {
          throw new Error(json.description || json.message || 'Unable to add to cart');
        }
        return json;
      });
    }).then(function (addJson) {
      var cartType = window.themeVariables && window.themeVariables.settings
        ? window.themeVariables.settings.cartType
        : 'popover';

      if (cartType === 'page') {
        window.location.href = getRoot() + 'cart';
        return null;
      }

      return fetch(getRoot() + 'cart.js', { credentials: 'same-origin' })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          cart.sections = addJson.sections || {};
          publishVariantAdd(addJson, cart);
          return cart;
        });
    });
  }

  function setButtonBusy(button, busy) {
    if (!button) return;
    button.classList.toggle('is-loading', !!busy);
    button.setAttribute('aria-busy', busy ? 'true' : 'false');
  }

  function handleAddClick(event) {
    var button = event.target.closest('a.addbutton, button.addbutton, .addbutton');
    if (!button) return;
    if (!button.closest('.wishlistbodycontainer, .wishlistpage, .container.wishlistbodycontainer')) return;

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    if (button.getAttribute('aria-busy') === 'true') return;
    setButtonBusy(button, true);

    resolveVariantId(button)
      .then(function (variantId) {
        if (!variantId) {
          throw new Error('Could not find product variant. Please open the product page to add it.');
        }
        return addVariantToCart(variantId);
      })
      .catch(function (error) {
        console.error('[wishlist-cart-fix]', error);
        window.alert(error.message || 'Unable to add product to cart');
      })
      .finally(function () {
        setButtonBusy(button, false);
      });
  }

  // Capture phase — run before theme hash smooth-scroll
  document.addEventListener('click', handleAddClick, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      loadWishlistApi();
    });
  } else {
    loadWishlistApi();
  }
})();
